"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icons = _interopRequireDefault(require("../assets/svg/icons.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Icon = function Icon(props) {
  var wrapperClass = (0, _classnames.default)('icon', "icon-".concat(props.icon), props.className ? props.className.split(' ') : '');
  return _react.default.createElement("svg", _extends({}, props, {
    className: wrapperClass,
    role: "img",
    title: props.title ? "\xCDcone ".concat(props.title) : 'Ícone'
  }), _react.default.createElement("use", {
    xlinkHref: "".concat(props.url, "#icon-").concat(props.icon)
  }));
};

Icon.propTypes = {
  title: _propTypes.default.string,
  className: _propTypes.default.string,
  icon: _propTypes.default.string.isRequired,
  url: _propTypes.default.string
};
Icon.defaultProps = {
  url: _icons.default
};
var _default = Icon;
exports.default = _default;